const routes: Record<string, string> = {
  INDEX: '/',

  EDIT_TEAM: '/:pageType(edit|manage)/:teamGuid/edit-team',
  SETTINGS: '/:pageType(edit|manage)/:teamGuid/settings',
  EDIT_MEMBERS: '/:pageType(edit|manage)/:teamGuid/edit-members',
};

export default routes;

// TODO Delete all reducer, actions and selectors around mode, and tests
